
const formdata = state => state.formdata;
const data = state => param => state.data[param];
const dataobject = state => state.data;
const entities = state => state.entities;
const ingredients = state => state.ingredients;
const getsingle = state => param =>state.entities.find((a)=> a.id == param)
const getshowresult = state => state.showresult








export default {
  formdata,
  data,
  entities,  
  dataobject,
  getsingle,
  getshowresult,  
  ingredients,
 
};